import { useCallback, useEffect, useRef, useState } from 'react'

import { StatusSelect } from './StatusSelect'
import { ClientStatus } from 'models/clientStatusHistory'
import { useEditClient } from 'modules/Clients/hooks/useEditClient'
import { useConfirmationDialog } from 'components/ConfirmationDialog'
import { addDays } from 'utils/datetime'
import { getCurrentClientStatus } from 'modules/Clients/helpers/utils'

export function StatusChange() {
  const { client, fetchClient, updateClientStatus, clientStatus } =
    useEditClient()

  const [status, setstatus] = useState<ClientStatus>()
  const [showConfirmationDialog] = useConfirmationDialog()
  const effectiveDateRef = useRef<Date | undefined>(undefined)

  useEffect(() => {
    if (!client) {
      fetchClient()
    }
  }, [client, fetchClient])

  useEffect(() => {
    if (client) {
      setstatus(clientStatus)
    }
  }, [client, clientStatus])

  const onStatusChange = useCallback(
    (newStatus: ClientStatus) => {
      effectiveDateRef.current = undefined

      const currentStatusDate = getCurrentClientStatus(
        client?.relationships?.statuses
      )?.attributes?.created_at
      // +1 dia: o back rejeita datas iguais ao status atual (effectiveAt <= created_at)
      const minDate = currentStatusDate
        ? addDays(new Date(currentStatusDate), 1)
        : new Date('2000-01-01')

      showConfirmationDialog({
        title: 'Alterar situação',
        message: 'Tem certeza que deseja alterar a situação do cliente?',
        datePicker: true,
        datePickerAttributes: { minDate, maxDate: new Date() },
        date: new Date(),
        onDateChange: (val) => {
          const d = val instanceof Date ? val : new Date(val)
          effectiveDateRef.current = d
          return d
        },
        onConfirm: () => updateClientStatus(newStatus, effectiveDateRef.current)
      })
    },
    [client, showConfirmationDialog, updateClientStatus]
  )

  return <StatusSelect value={status} onChange={onStatusChange} />
}
